import React, { Component } from 'react';
import { observer } from 'mobx-react';

import Button from '../../components/Button/index';
import './Error.css';

@observer
class Error extends Component {
    back = (e) => {
        e.stopPropagation();
        this.props.history.goBack()
    };
    render() {
        return (
            <div className={(this.props.appStore.isMobile) ? "Error mobile": "Error desktop" }>
                <div className="container">
                    <h2>
                        Unfortunately there was an error submitting your answers to the survey.
                    </h2>
                    <h2>
                        Please try again after a few minutes.
                    </h2>
                    <Button className='closeButton'
                            onClick={this.back}
                            aria-label="Close button">
                        <i className="fa fa-times" aria-hidden="true"/>
                    </Button>
                </div>
            </div>
        );
    }
}

export default Error;


// WEBPACK FOOTER //
// ./src/scenes/Error/index.js